export default function scrollToTop(behavior = "smooth" as ScrollBehavior) {
  window.scroll({
    top: 0,
    left: 0,
    behavior
  })
}
